<script>
import TheLegacyBullhornDataContainer from '@/components/candidate/bullhorn/the-legacy-bullhorn-data-container.vue'
import Layout from '@layouts/main.vue'

export default {
  name: 'LegacyBullhornView',
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'The Legacy Bullhorn page.' }],
    }
  },
  components: { Layout, TheLegacyBullhornDataContainer },
  props: {
    candidateId: {
      type: String,
      required: true,
    },
  },
  computed: {
    parsedCandidateId() {
      return parseInt(this.candidateId) || -1
    },
  },
}
</script>

<template>
  <Layout>
    <TheLegacyBullhornDataContainer :candidate-id="parsedCandidateId" />
  </Layout>
</template>
